<template>
  <div class="Profile h-100 flex-column text-center">
    <img :src="userProfile.logo_thumbnail" :alt="userProfile.company_name" style="width:240px;margin-bottom: 20px;" />
    <br>
    {{this.resourceName}}
  </div>
</template>

<script>
import { getResourceUser } from '../utils/api'

export default {
  props: {
    resource: String
  },
  data () {
    return {
      rows: [],
      hasError: false,
      resourceName: ''
    }
  },
  computed: {
    userProfile () {
      if (this.rows.logo) {
        return this.rows
      }

      return { 'logo_thumbnail': null, 'company_name': null }
    }
  },
  mounted () {
    this.getProfile()
  },
  methods: {
    getProfile () {
      getResourceUser(this.resource).then((data) => {
        if (data) {
          this.rows = data
          this.resourceName = data.resource_title
          if (this.hasError) {
            this.hasError = false
          }
        } else {
          this.hasError = true
        }
      }).catch(() => {
      // }).catch((error) => {
        // console.log(error)
        this.hasError = true
      })
    }
  }
}
</script>
